import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function emailValidator(): ValidatorFn {
  const emailPattern = /^[a-zA-Z0-9](?!.*\.\.)[a-zA-Z0-9._%+-]*@[a-zA-Z0-9]+(-[a-zA-Z0-9]+)*(\.[a-zA-Z]{2,})+$/;
  return (control: AbstractControl): ValidationErrors | null => {
    const emailValid = emailPattern.test(control.value);
    return emailValid ? null : { email: 'Email is not valid' };
  };
}
